import React from 'react';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import theme from './theme';
import ParticleBackground from './components/ParticleBackground';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import UseCasesSection from './components/UseCasesSection';
import TechnicalSection from './components/TechnicalSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ backgroundColor: '#000000', minHeight: '100vh', position: 'relative' }}>
        <ParticleBackground />
        <Box sx={{ position: 'relative', zIndex: 1 }}>
          <Navigation />
          <HeroSection />
          <AboutSection />
          <FeaturesSection />
          <UseCasesSection />
          <TechnicalSection />
          <ContactSection />
          <Footer />
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default App;
